var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Redirect, Route } from "react-router";
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Grid, Header, Input, List, Loader, Message, Modal } from "semantic-ui-react";
import { AppPaths } from "./AppConfig";
import { ORIGIN } from "./Config";
import ErrorDisplay from "./ErrorDisplay";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
import { postJsonNoAuthn, postJsonWithAuthn } from "./RequestHelpers";
var LogInPage = /** @class */ (function (_super) {
    __extends(LogInPage, _super);
    function LogInPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onEmailChange = function (_, data) {
            var str = data.value;
            _this.setState({ email: str });
        };
        _this.onPasswordChange = function (_, data) {
            var str = data.value;
            _this.setState({ password: str });
        };
        _this.loginButton = function () {
            var onClick = function () {
                _this.setState({
                    loading: true,
                    errors: []
                }, function () {
                    var reqBody = {
                        email: _this.state.email,
                        password: _this.state.password,
                    };
                    // even though we have no credentials to send, have to have it set for the request or set-cookie won't
                    // work
                    postJsonWithAuthn('/user/log-in', JSON.stringify(reqBody))
                        .then(function (resp) {
                        if (resp.status === 200) {
                            resp.json().then(function (r) { return gtag('event', 'login', {
                                method: 'email',
                                user_id: r.userId
                            }); }).catch(function (rej) {
                                console.error("Couldn't track log in: " + rej);
                            });
                            _this.setState({
                                loading: false,
                                errors: []
                            }, function () {
                                _this.props.authnObserver.onAuthnStateChanged();
                                _this.setState({
                                    loading: false,
                                    success: true,
                                });
                            });
                            return;
                        }
                        else if (resp.status === 400) {
                            // 400: obviously wrong submission
                            return resp.json();
                        }
                        else {
                            // 401: bad authn -- only one way to handle that so we just map it to an error here
                            _this.setState({
                                loading: false,
                                errors: [{
                                        path: '/',
                                        msg: 'Log in failed. Have you verified your email address?'
                                    }]
                            });
                            return;
                        }
                    })
                        .then(function (resp) {
                        if (resp !== undefined) {
                            _this.setState({
                                loading: false,
                                errors: resp.errors
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't log in: " + rej);
                    });
                });
            };
            return React.createElement(Button, { icon: 'sign in', label: 'Log in', labelPosition: 'left', onClick: onClick, positive: true });
        };
        _this.state = {
            success: false,
            loading: false,
            errors: [],
            email: '',
            password: ''
        };
        return _this;
    }
    LogInPage.prototype.render = function () {
        if (this.state.success) {
            var routerState = this.props.routerProps.location.state;
            if ((typeof routerState === "object")
                && routerState !== null
                && routerState.hasOwnProperty('referrerLocation')) {
                var r = routerState.referrerLocation;
                // using a Redirect rather than pushing onto history allows us to use a complete Location as the `to`,
                // so query params etc will carry over
                return React.createElement(Redirect, { to: r });
            }
            else {
                return React.createElement(Redirect, { to: { pathname: AppPaths.CART, state: { mounted: false } } });
            }
        }
        if (this.props.authenticated) {
            return React.createElement(Redirect, { to: { pathname: AppPaths.PROFILE, state: { mounted: false } } });
        }
        return React.createElement(Dimmer.Dimmable, { id: "non-header-portion", as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Header, null, "Log in"),
            React.createElement("p", null,
                React.createElement(Link, { to: AppPaths.REGISTER }, "Register"),
                " if you are a new user"),
            ORIGIN === "mi" && React.createElement(Message, { info: true },
                React.createElement(List, null,
                    React.createElement(List.Item, null, "Register as a new user and log in to see applicable discounts"))),
            React.createElement("div", { className: 'field-group' },
                React.createElement(Grid, { columns: 3 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errorPath: '/email', errors: this.state.errors, labelContent: 'Email', labelFor: 'email', required: true },
                                React.createElement(Input, { name: 'email', type: 'email', onChange: this.onEmailChange, value: this.state.email })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errorPath: '/password', errors: this.state.errors, labelContent: 'Password', labelFor: 'password', required: true },
                                React.createElement(Input, { name: 'password', type: 'password', onChange: this.onPasswordChange, value: this.state.password })))))),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement(Route, { render: this.loginButton }),
            React.createElement(Modal, { closeIcon: true, size: 'small', trigger: React.createElement(Button, { icon: 'privacy', label: 'I forgot my password', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Send a password reset email"),
                React.createElement(Modal.Content, null,
                    React.createElement(Modal.Description, null,
                        React.createElement(SendPasswordResetForm, null)))));
    };
    return LogInPage;
}(React.PureComponent));
export default LogInPage;
var SendPasswordResetForm = /** @class */ (function (_super) {
    __extends(SendPasswordResetForm, _super);
    function SendPasswordResetForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onEmailChange = function (event, data) {
            var str = data.value;
            _this.setState({ email: str });
        };
        _this.onSendEmailClick = function () {
            _this.setState({
                loading: true
            }, function () {
                var reqBody = {
                    email: _this.state.email,
                };
                postJsonNoAuthn('/user/generate-reset-password-token', JSON.stringify(reqBody))
                    .then(function (resp) {
                    if (resp.status === 200) {
                        _this.setState({
                            loading: false,
                            error: false,
                            success: true
                        });
                    }
                    else {
                        // something went wrong
                        _this.setState({
                            loading: false,
                            error: true,
                            success: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't generate reset pw token: " + rej);
                });
            });
        };
        _this.state = {
            error: false,
            loading: false,
            success: false,
            email: ''
        };
        return _this;
    }
    SendPasswordResetForm.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Form.Field, { required: true },
                React.createElement("label", null, "Email"),
                React.createElement(Input, { disabled: this.state.success, onChange: this.onEmailChange, type: 'email', value: this.state.email })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Please check your email; a message with a password reset link should arrive shortly."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "An error occurred."),
            React.createElement(Button, { disabled: this.state.success, icon: 'mail', label: 'Send password reset email', labelPosition: 'left', onClick: this.onSendEmailClick, positive: true }));
    };
    return SendPasswordResetForm;
}(React.PureComponent));
//# sourceMappingURL=LogInPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/LogInPage.js
// module id = 622
// module chunks = 0